"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.visibilityAwareTimeoutPolling = void 0;
const polling_1 = __importDefault(require("../../../common/utils/polling"));
const waitUntil_1 = require("./waitUntil");
const ONE_SECOND = 1000;
const ONE_MINUTE = 60 * ONE_SECOND;
function visibilityAwareTimeoutPolling(fn, condition, _a) {
    var { timeout = 10 * ONE_MINUTE, visibilityCheckInterval = ONE_SECOND, visibilityCheckTimeout = 10 * ONE_MINUTE } = _a, options = __rest(_a, ["timeout", "visibilityCheckInterval", "visibilityCheckTimeout"]);
    return __awaiter(this, void 0, void 0, function* () {
        let resolver;
        let rejecter;
        const promiseWithResolvers = new Promise((resolve, reject) => {
            resolver = resolve;
            rejecter = reject;
        });
        let stopPolling = false;
        function listener() {
            stopPolling = document.hidden;
        }
        document.addEventListener("visibilitychange", listener);
        (0, polling_1.default)(() => __awaiter(this, void 0, void 0, function* () {
            if (stopPolling) {
                yield (0, waitUntil_1.waitUntil)({ condition: () => !stopPolling, interval: visibilityCheckInterval, timeout: visibilityCheckTimeout });
            }
            return yield fn();
        }), condition, Object.assign({ timeout }, options))
            .then((response) => {
            resolver(response);
        })
            .catch(rejecter)
            .finally(() => {
            document.removeEventListener("visibilitychange", listener);
        });
        return promiseWithResolvers;
    });
}
exports.visibilityAwareTimeoutPolling = visibilityAwareTimeoutPolling;
